import { useTranslation } from 'react-i18next';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { Button } from './Button';
import { Text } from './Text';

const ReloadPrompt = () => {
  const { t } = useTranslation();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({ immediate: true });

  const close = () => {
    setNeedRefresh(false);
  };

  return (
    <>
      {needRefresh && (
        <div className="fixed bottom-4 right-4 z-50 m-4 max-w-sm rounded-lg border-secondary bg-linko-light p-4 text-left shadow-lg">
          <div className="mb-3">
            <Text className="text-sm font-medium text-primary">
              {t('reloadPrompt:needRefresh')}
            </Text>
          </div>
          <div className="flex justify-end gap-3">
            <Button onClick={() => updateServiceWorker(true)}>
              {t('reloadPrompt:reload')}
            </Button>
            <Button className="bg-danger" onClick={() => close()}>
              {t('reloadPrompt:close')}
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default ReloadPrompt;
